// extracted by mini-css-extract-plugin
export default {"myStuffEmptyContainer":"lqiYY","icon":"cD4Vo","content":"KWqqr","title":"FV2Rl","subtitle":"APwGY"};